import type { NeoShoppingCart } from "@expert/types";
import type { ShopCartItem, ShoppingCart } from "~~/models/shoppingCart";

export const mapShoppingCartFromNeo = (shoppingCart: NeoShoppingCart): ShoppingCart => {
    if(!shoppingCart)
        return;
    const cart: ShoppingCart = {
        cartType: shoppingCart.cartType,
        cartId: shoppingCart.id,
        coupons: shoppingCart.coupons,
        currency: shoppingCart.currency,
        itemList: [],
        itemListId: shoppingCart.itemList?.id,
        subTotalBill: 0,
        overAllQuantity: 0,
    };

    let counter: number = 0;
    for (const cartItem of shoppingCart.itemList?.items) {
        const mappedCartItem: ShopCartItem = {
            ...cartItem,
            additionalPriceSum: 0,
        };

        for (const additionalItem of cartItem.additionalItems?.items ?? []) {
            mappedCartItem.additionalPriceSum += additionalItem.price.gross;
        }

        cart.itemList.push(mappedCartItem);
        counter += cartItem.price?.gross * cartItem.quantity;
    }

    cart.subTotalBill = counter;
    cart.overAllQuantity = cart.itemList.reduce((count: number, item: ShopCartItem) => {
          return (item.quantity ?? 1) + count
        }, 0) ?? 0;

    return cart;
}